import { render, staticRenderFns } from "./HubMatch.vue?vue&type=template&id=837938b2&scoped=true"
import script from "./HubMatch.vue?vue&type=script&lang=js"
export * from "./HubMatch.vue?vue&type=script&lang=js"
import style0 from "./HubMatch.vue?vue&type=style&index=0&id=837938b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837938b2",
  null
  
)

export default component.exports